import { CallbackObject } from 'api/core/get-page-function';
import { GetServerVm } from './get-server.vm';
import { AxiosResponse } from 'axios';
import { plainToClass } from 'class-transformer';
import { instance } from 'api/core';

export const getServer = async (serverId: string, callback: CallbackObject<GetServerVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/asrs/servers/${serverId}`, config);
    callback.success(plainToClass(GetServerVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
